<template>
  <div>
    <slot></slot>
    <div 
      class="poster-wrap isFixHeight" 
      v-if="isShow"
      @touchstart="handlerTouchstart"
      @touchmove="handlerTouchmove"
      @touchend="handlerTouchend"
    >
      <img class="poster-image" :src="posterUrl" alt="" />
      <i class="close-icon"></i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    posterUrl: {
      type: String,
      default: '',
    },
    isShow: {
      type: Boolean,
      default: () => false,
    }
  },
  mounted() {
    document.title = '过五关斩六将'
  },
  data() {
    return {
      loop: 0,
    };
  },
  methods: {
    handlerTouchstart() {
      this.loop = setTimeout(() => {
        this.loop = 0;
        // 执行长按要执行的内容
      }, 500); // 定时的时间
      return false;
    },
    handlerTouchmove() {
      // 清除定时器
      clearTimeout(this.loop);
      this.loop = 0;
    },
    handlerTouchend() {
      // 清除定时器
      clearTimeout(this.loop);
      if (this.loop !== 0) {
        // 单击操作
        this.$emit("OnCancelPoster", false);
      }
    },
    handleCancelPoster() {
      this.$emit("OnCancelPoster", false);
    },
  },
}
</script>

<style lang="less" scoped>
.poster-wrap {
  position: relative;
  width: 100%;
  z-index: 100;
  text-align: center;
  background: rgba(0, 0, 0, 0.7);
  .poster-image {
    display: block;
    width: 100%;
    // object-fit: cover;
  }
  .close-icon {
		position: absolute;
		width: 64px;
		height: 64px;
		top: 40px;
		right: 10px;
		background: url('../../../assets/images/winterGame/close.png') no-repeat center center;
		background-size: 100% 100%;
		&.star-member {
			top: 90px;
			right: 20px;
		}
	}
}

.poster-wrap .isFixHeight {
	height: 100vh;
	.poster-image {
		width: auto;
		height: 100%;
		margin: auto;
	}
}
  
</style>